import { MaskedLines, Reveal } from "./Reveal";

// Inner-page hero: eyebrow, masked headline, supporting copy. Left-aligned editorial.
export function PageHero({ eyebrow, lines, copy, dark = false, children }) {
  return (
    <section className={`${dark ? "noise-dark text-zinc-100" : "bg-paper text-charcoal"} relative overflow-hidden pt-32 md:pt-44`}>
      <div className={`absolute inset-0 ${dark ? "grid-lines-dark" : "grid-lines"}`} aria-hidden="true" />
      <div className="container-x relative pb-16 md:pb-24">
        <Reveal>
          <p className={dark ? "eyebrow-dark" : "eyebrow"}>{eyebrow}</p>
        </Reveal>
        <MaskedLines
          as="h1"
          lines={lines}
          delay={0.1}
          className={`h-display mt-6 max-w-5xl text-4xl sm:text-5xl lg:text-6xl ${dark ? "text-zinc-50" : "text-charcoal"}`}
        />
        {copy && (
          <Reveal delay={0.35}>
            <p className={`mt-8 max-w-2xl text-base leading-relaxed md:text-lg ${dark ? "text-zinc-400" : "text-zinc-600"}`}>{copy}</p>
          </Reveal>
        )}
        {children}
      </div>
    </section>
  );
}
